/**
 * Fix 4 (Frank, 5 nov 2026): het ruwe bronblok ("[uit de bronnen]", met regels als
 * "venster :: ...") staat niet onder een workeruitslag in de Postbus, alleen achter
 * "Laat je werk zien". Gemeten in het TASQ-dagoverzicht van 5 november: veertig regels
 * bron onder het overzicht.
 *
 * Geknipt op het EERSTE voorkomen, net als `agendablok.splits` en `bronstrijd.tegenspraak`:
 * alles wat de backend erna plakt, hoort bij het bewijs. PUUR.
 */
export const BRONKOP = "\n---\n[uit de bronnen]";

export function splitsBron(antwoord) {
  const heel = antwoord || "";
  const i = heel.indexOf(BRONKOP);
  if (i === -1) return { tekst: heel, bron: "" };
  return {
    tekst: heel.slice(0, i).replace(/\s+$/, ""),
    bron: heel.slice(i + 1).replace(/^---\n/, "").trim(),
  };
}
